import {autoinject, bindable} from 'aurelia-framework';
import {Dispatch} from "../services/dispatch";

@autoinject()
export class RevealOnHoverCustomAttribute {

  @bindable({ primaryProperty: true }) tag: string;

  constructor(private element: Element,
              private dispatch: Dispatch) {

    this.element.addEventListener('mouseenter', ()=> {
      this.mouse_enter();
    });

    this.element.addEventListener('mouseleave', () => {
      this.mouse_leave();
    });

  }


  mouse_enter() {
    this.dispatch.setState(this.tag, 'reveal');
  }

  mouse_leave() {
    this.dispatch.setState(this.tag, null);
  }

}
